module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gatsby-eui-starter","short_name":"starter","start_url":"/","background_color":"#F5F7FA","theme_color":"#006BB4","display":"minimal-ui","icon":"src/images/hail-logo-favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"c73470375fd0d66202c52d25ff52bb99"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
